import React, { Component, Fragment } from "react";
import {
  MeetingNotesServices,
  DevelopmentServices,
  UtilityService
} from "../../services";
import Async from "react-select";
import "react-select/dist/react-select.css";
import Modal from "react-responsive-modal";
import moment from "moment";

//redux
import { connect } from "react-redux";
import * as mainAction from "../../redux/action/main";
import { bindActionCreators } from "redux";

//components
import PageHeader from "../../components/Page/PageHeader/PageHeader";
import Field from "../../components/Common/Field/Field";
import FileUpload from "../../components/FileUpload/FileUpload";
import Button from "../../components/Buttons/Button";

class DevelopmentSourcing extends Component {
  state = {
    action: "",
    _id: "",

    meetingNoteValue: "",
    soucingReqNo: "",

    images: [],
    imageForModal: "",
    openModal: false,

    sourceId: "",
    sourcingData: {
      sourcingNumber: null,
      date: null,
      magnumStyleId: null,
      MNID: null,
      requestGeneratedBy: null,
      sourcingFor: "",
      originationOfRequest: "",
      season: "",
      category: "",
      requirement: "",
      color: "",
      quantity: "",
      composition: "",
      measurement: "",
      dateRequiredAtMagnum: undefined,
      dateReceivedAtMagnum: undefined,
      additionalInfo: "",
      refImages: []
    },

    //dummy value for selecting Async
    styleNo: null,
    disabled: false
  };

  componentWillMount() {
    this.getMagnumStyleNo("");

    let action = this.props.location.state.action;
    let _id = this.props.location.state._id;

    if (action === "view") {
      this.setState({ disabled: true });
    }

    if (_id !== "") {
      DevelopmentServices.getSpecificSource(_id)
        .then(response => {

          if (response.status === 200) {
            let sourcingData = response.text.data;

            let meetingNoteId = sourcingData.MNID.MNId;
            sourcingData.MNID = sourcingData.MNID._d;
            sourcingData.requestGeneratedBy =
              sourcingData.requestGeneratedBy.firstName +
              " " +
              sourcingData.requestGeneratedBy.lastName;
            sourcingData.date = new Date(sourcingData.date);
            sourcingData.dateRequiredAtMagnum = new Date(
              sourcingData.dateRequiredAtMagnum
            );
            sourcingData.dateReceivedAtMagnum = new Date(
              sourcingData.dateReceivedAtMagnum
            );
            let styleNo = {
              label: sourcingData.magnumStyleId.styleNumber,
              value: sourcingData.magnumStyleId._id
            };
            sourcingData.magnumStyleId = sourcingData.magnumStyleId._id;
            this.setState({
              sourcingData,
              meetingNoteId,
              styleNo
            });
          }
          response.status === 401 && this.props.unauthorisedFunc();
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }

    this.setState({
      action,
      _id
    });

    let sourcingData = { ...this.state.sourcingData };
    sourcingData.requestGeneratedBy = this.props.userData.userName;
    this.setState({ sourcingData });
  }

  componentWillReceiveProps(nextProps) { }

  searchMeetingNote = e => {
    e.preventDefault();
    MeetingNotesServices.searchMeetingNotesBy(
      this.state.searchMeetingNotesBy,
      this.state.meetingNoteValue
    )
      .then(response => {
        if (response.status === 200) {
          this.setState({ meetingNotes: response.text.data.MN });
        }
      })
      .catch(error => {
        this.props.getalertMessage('error', error.toString());
      });
  };

  createSourcing = e => {
    e.preventDefault();
    let data = { ...this.state.sourcingData };

    DevelopmentServices.createSource(data)
      .then(response => {
        if (response.status === 200) {
          this.props.getalertMessage("success", this.msg);
          this.props.history.push("/list", { moduleName: 'SOURCING' });
        }
        response.status === 401 && this.props.unauthorisedFunc();
      })
      .catch(error => {
        this.props.getalertMessage('error', error.toString());
        this.props.get;
      });
  };

  getMagnumStyleNo = value => {
    DevelopmentServices.getMagnumStyleNo(value)
      .then(response => {
        if (response.message === "Operation Successful") {
          let jsonData = [];
          response.data.map((info, index) => {
            let objData = {};
            objData.label = info.styleNumber;
            objData.value = info._id;
            jsonData.push(objData);
          });
          this.setState({ styleNoInfo: jsonData });
        }
      })
      .catch(error => {
        this.props.getalertMessage('error', error.toString());
      });
  };

  changeStyleNo = styleNo => {
    alert(styleNo, " style value onchagen");
    let sourcingData = { ...this.state.sourcingData };
    sourcingData.magnumStyleId = styleNo.value;
    this.setState({ styleNo, sourcingData });
  };

  completeSource = e => {
    e.preventDefault();
    DevelopmentServices.completeSource(this.state.sourceId)
      .then(response => {
        if (response.status === 200) {

        }
        response.status === 401
      })
      .catch(error => {

        this.props.getalertMessage('error', error.toString());
      });
  };

  //jayaprakash
  updateValue = (name, value) => {
    let sourcingData = { ...this.state.sourcingData };
    sourcingData[name] = value;
    this.setState({ sourcingData });
  };

  getSourcingImages = refImages => {
    let sourcingData = { ...this.state.sourcingData };
    sourcingData.refImages = refImages;
    this.setState({
      sourcingData
    });
  };

  updateMeetingNotes = meetingNote => {

    let sourcingData = { ...this.state.sourcingData };
    sourcingData.MNID = meetingNote._id;
    this.setState({ meetingNoteId: meetingNote.MNId, sourcingData });
  };

  render() {
    const { sourcingData, meetingNoteId } = this.state;

    return (
      <Fragment>
        <div class="right-section">
          <div class="row nopadding bg-white">
            <PageHeader
              history={this.props.history}
              header="Sourcing"
            />
            <form id="sourcing" className="sourceTableWrapper">
              <div class="col-md-12 product-form no-padding">
                <div class="col-md-12 nopadding">
                  <table class="responsive-table">
                    <tbody>
                      {this.state.sourcingData.sourcingNumber !== null && (
                        <tr>
                          <td>
                            <b>Sourcing Req No.</b>
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              value={sourcingData.sourcingNumber}
                              disabled
                            />
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td>
                          <b>Date</b>
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            value={sourcingData.date}
                            inputName="date"
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>

                        <td class="text-right">
                          <b>Magnum Style No.</b>
                        </td>
                        <td>
                          <div class="custom-async-select">
                            <Async
                              name="form-field-name"
                              value={this.state.styleNo}
                              onInputChange={e => this.getMagnumStyleNo(e)}
                              onChange={this.changeStyleNo}
                              placeholder="Find Style"
                              options={this.state.styleNoInfo}
                              disabled={this.state.disabled}
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <b>Meeting Notes</b>
                        </td>
                        <td>
                          <div class="col-md-10 no-padding">
                            <input
                              type="text"
                              class="form-control"
                              placeholder=""
                              name=""
                              value={meetingNoteId}
                              disabled={this.state.disabled}
                            />
                          </div>

                          {!this.state.disabled && (
                            <div class="col-md-2 nopadding">
                              <span class="popup-box">
                                <a
                                  href="#"
                                  style={{ borderRadius: 0 }}
                                  data-toggle="modal"
                                  data-target="#myModal"
                                />
                              </span>
                            </div>
                          )}
                        </td>

                        <td class="text-right">
                          <b>Request generated by</b>
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="userName"
                            name="requestGeneratedBy"
                            value={sourcingData.requestGeneratedBy}
                            disabled
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <b>Sourcing For</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="text"
                            inputName="sourcingFor"
                            placeholder="MATLAN-GIRLSWEAR"
                            value={sourcingData.sourcingFor}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>

                        <td class="text-right">
                          <b>Origination Of Request</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="select"
                            inputName="originationOfRequest"
                            options={[
                              { label: "Meeting Notes", value: "Meeting Notes" }
                            ]}
                            value={sourcingData.originationOfRequest}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <b>Season</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="text"
                            inputName="season"
                            placeholder="AW18"
                            value={sourcingData.season}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>

                        <td class="text-right">
                          <b>Category</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="select"
                            inputName="category"
                            options={[
                              { label: "Fabric", value: "Fabric" },
                              { label: "Trim", value: "Trim" }
                            ]}
                            value={sourcingData.category}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <b>Requirement</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="text"
                            inputName="requirement"
                            placeholder="PATCHWORK"
                            value={sourcingData.requirement}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>

                        <td class="text-right">
                          <b>Color Stds</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="text"
                            inputName="color"
                            placeholder="AW 18 COL PALETTE"
                            value={sourcingData.color}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <b>Quantity</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="number"
                            inputName="quantity"
                            placeholder="20 SWATCHES"
                            value={sourcingData.quantity}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>

                        <td class="text-right">
                          <b>Composition</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="text"
                            inputName="composition"
                            placeholder="POLYESTER"
                            value={sourcingData.composition}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <b>Measurement</b>
                        </td>
                        <td>
                          <Field
                            isFormGroup={false}
                            inputType="text"
                            inputName="measurement"
                            placeholder=""
                            value={sourcingData.measurement}
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>

                        <td class="text-right">
                          <b>Date Reqd At Magnum</b>
                        </td>
                        <td class="text-left">
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            value={sourcingData.dateRequiredAtMagnum}
                            inputName="dateRequiredAtMagnum"
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <b>Date Received At Magnum</b>
                        </td>
                        <td class="text-left">
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            value={sourcingData.dateReceivedAtMagnum}
                            inputName="dateReceivedAtMagnum"
                            onChange={this.updateValue}
                            disabled={this.state.disabled}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="col-md-12 px-5">
                  <Field
                    isFormGroup={true}
                    inputType="textarea"
                    inputName="additionalInfo"
                    value={sourcingData.additionalInfo}
                    label="Additional Info"
                    onChange={this.updateValue}
                    disabled={this.state.disabled}
                  />
                </div>
                <FileUpload
                  Heading="Upload Images"
                  getRefImages={this.getSourcingImages}
                  disabled={this.state.disabled}
                  uploadedDocs={
                    this.state.action === "view" || this.state.action === "edit"
                      ? sourcingData.refImages
                      : null
                  }
                />
                <div class="col-md-12 no-padding text-center profile-btn">
                  {/* <button type="button" class="primary" name="button" onClick={(e) => this.createSourcing(e)}>Save</button>  */}
                  <Button
                    buttonName="save"
                    buttonType="save"
                    onClick={this.createSourcing}
                  />
                  {this.state.sourcingData.sourcingNumber !== null && (
                    <button
                      type="button"
                      class="primary"
                      onClick={e => this.completeSource(e)}
                      name="button"
                    >
                      Complete
                    </button>
                  )}
                  <Button
                    buttonName="cancel"
                    buttonType="cancel"
                    history={this.props.history}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>

        <div id="myModal" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body no-padding">
                <div class="col-md-12 no-padding">
                  <div class="col-md-8 product-form no-padding">
                    <div class="col-md-6 nopadding">
                      <div class="form-group">
                        <label for="phone">Search Style</label>
                        <br />
                        <span>BY</span>
                        <br />
                        <select
                          class="form-control"
                          name=""
                          onChange={e =>
                            this.setState({
                              searchMeetingNotesBy: e.target.value
                            })
                          }
                        >
                          <option value="style">Select</option>
                          <option value="MNId">Meeting Notes No</option>
                          <option value="customerName">Customer Name</option>
                          <option value="customerDepartment">
                            Departement Name
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6 no-padding">
                      <div class="form-group">
                        <label for="ref-no" />
                        <br />
                        <span>FOR</span>
                        <br />
                        <input
                          type="text"
                          class="form-control"
                          name="meetingNoteValue"
                          value={this.state.meetingNoteValue}
                          onChange={e =>
                            this.setState({ meetingNoteValue: e.target.value })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 product-form">
                    <div class="col-md-12 mm-btns" style={{ marginTop: "32%" }}>
                      <button
                        type="button"
                        class="primary"
                        name="button"
                        onClick={e => this.searchMeetingNote(e)}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 no-padding">
                  <div class="table-container">
                    <table class="table">
                      <thead>
                        <tr>
                          <th data-field="num">Meeting Notes No</th>
                          <th data-field="name">Customer Name</th>
                          <th data-field="name">Deptartment Name</th>
                          <th data-field="act">Action</th>
                          <th data-field="select">Select</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.meetingNotes !== undefined &&
                          Array.isArray(this.state.meetingNotes) &&
                          this.state.meetingNotes.length > 0 &&
                          this.state.meetingNotes.map((meetingNote, index) => (
                            <tr>
                              <td>
                                {meetingNote.MNId !== null && meetingNote.MNId}
                              </td>
                              <td>
                                {meetingNote.customerName !== null &&
                                  meetingNote.customerName}
                              </td>
                              <td>
                                {meetingNote.customerDepartmentName !== null &&
                                  meetingNote.customerDepartmentName}
                              </td>
                              <td>
                                <a
                                  href=""
                                  class="view"
                                  title="View"
                                  onClick={() =>
                                    this.props.history.push(
                                      "/viewMeeting?" + meetingNote._id
                                    )
                                  }
                                >
                                  <i class="material-icons">visibility</i>
                                </a>
                              </td>
                              <td>
                                <input
                                  type="radio"
                                  name="gender"
                                  class="sourcingOption"
                                  data-dismiss="modal"
                                  onClick={() =>
                                    this.updateMeetingNotes(meetingNote)
                                  }
                                />
                                <br />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={this.state.openModal}
          onClose={() => this.setState({ openModal: false })}
          s
          center
        >
          <img
            src={
              this.state.imageForModal !== "" &&
              window.URL.createObjectURL(this.state.imageForModal)
            }
            style={{ width: "100%" }}
          />
        </Modal>
      </Fragment>
    );
  }
}
// export default DevelopmentSourcing;
const mapStateToProps = state => {
  return {
    userData: state.main
  };
};

export default connect(
  mapStateToProps,
  null
)(DevelopmentSourcing);



// WEBPACK FOOTER //
// ./src/pages/developmentSourcing/page.js